// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__9twdD","visa":"style_visa__R3gYh","discover":"style_discover__-KxP-","mastercard":"style_mastercard__d7nXC","amex":"style_amex__A-XmQ"};